import { render } from "./FuturesProfitActionGraphWidgetLayout.vue?vue&type=template&id=25ada224"
import script from "./FuturesProfitActionGraphWidgetLayout.vue?vue&type=script&lang=js"
export * from "./FuturesProfitActionGraphWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script